import includes from "lodash/includes";
import isNumber from "lodash/isNumber";
import styled from "styled-components";
export const SIZES = {
    BTN_SIZE: 28
};
export default {
    ActionsMiniPanel: styled.div
        .withConfig({
        shouldForwardProp: (prop) => !includes(["hasRightSidePanel", "panelHeight"], prop)
    })
        .attrs({
        className: "border-bottom-gray-100"
    }) `
    height: ${({ panelHeight }) => (isNumber(panelHeight) ? `${panelHeight}px` : panelHeight) || "0px"};
    display: grid;
    grid-template-columns: ${({ hasRightSidePanel }) => (hasRightSidePanel ? "1fr auto" : "1fr")};
    align-items: center;
    > * {
      height: ${({ panelHeight }) => (isNumber(panelHeight) ? `${panelHeight}px` : panelHeight) || "0px"};
      padding: 0 ${({ theme }) => theme["padding-xxs"]};
      &:last-child {
        padding: 0 ${({ theme }) => theme["padding-xs"]};
      }
      &:first-child {
        padding-left: 0;
      }
    }
  `
};
